<template>
  <div class="cooperation-box">
    <div class="header">
      <div class="ctrl-bar-left">
        <b class="panel">任务协作</b>
        <div class="type-box">
          <span
            v-for="(category, index) in categoryList" :key="'category-'+index"
            @click="changeActive(category)"
            :class="['type', active === category.id ? 'active' : '']">
            {{ category.name }}{{ category.taskCount ? `(${category.taskCount})` : '' }}
          </span>
        </div>
      </div>
      <div class="ctrl-bar-right">
        <div @click="refresh" class="ctrl">刷新</div>
        <el-popover
          v-model="visible"
          placement="left-start"
          width="250"
          trigger="click"
          @show="queryConfig">
          <el-tree
            ref="configListTree"
            :data="configList"
            show-checkbox
            node-key="id"
            draggable
            @node-drop="handleDrop"
            @check="check"
            @check-change="handleCheckChange"
            :default-checked-keys="defaultCheckedKeys"
            :props="{ label: 'name', children: 'nodeList' }"
            :allow-drop="allowDrop"
            :expand-on-click-node="false">
            <span class="task-collaboration-tree-node" slot-scope="{ node }">
              <span>{{ node.label }}</span>
              <img :src="require('@/assets/reorder.svg')" />
            </span>
          </el-tree>
          <div style="text-align: right;margin-top: 5px;">
            <el-button size="mini" @click="visible = false">取消</el-button>
            <el-button @click="reset">重置</el-button>
            <el-button type="primary" size="mini" @click="handleSave">保存</el-button>
          </div>
          <div class="ctrl" slot="reference">设置</div>
        </el-popover>
      </div>
    </div>
    <div class="content">
      <div v-if="pointList.length" class="content-left">
        <div v-for="(point, index) in pointList" :key="'point-'+index"
          :class="['status-item', activePoint.id === point.id ? 'active' : '']">
          <div @click="changeActivePoint(point)" class="flex-box">
            <img :src="activePoint.id === point.id ? activeIcon : icon" alt="" class="status-icon" />
            <span class="status-label">{{ point.name }}</span>
            <span v-if="point.taskCount" class="status-count">{{ point.taskCount }}</span>
          </div>
          <img @click="toListPage(point)" :src="require('@/assets/icon_go.svg')" alt="" class="go"/>
        </div>
      </div>
      <div class="content-right">
        <template v-if="list && list.length">
          <div v-for="(item, index) in list" @click="toDetail(item)" :key="'info-'+index" class="row">
            <div class="line-1">{{ item.name }}</div>
            <div class="line-2">
              <span class="item">创建人：{{ item.businessCreateUserName }}</span>
              <span class="item">创建时间：{{ formatDate(item.businessCreateTime) }}</span>
              <span class="item">更新时间：{{ formatDate(item.businessUpdateTime) }}</span>
            </div>
          </div>
          <div @click="toListPage(activePoint)" class="more">查看更多</div>
        </template>
        <Empty v-else style="padding-top: 100px;" />
      </div>
    </div>
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import Empty from '@/components/empty.vue';
import { getConfig, saveConfig, resetConfig, taskPageList, getCategoryAndCount, noAlert } from '@/api/cooperation';

const taskEnums = {
  WAIT_TASK_ORDER: 'PENDING_ORDERS',
  WAIT_ASSIGN: 'TO_BE_ASSIGNED',
  WAIT_COMPLETE: 'TO_BE_COMPLETED',
};

export default {
  components: {
    Empty,
  },
  data () {
    return {
      active: '', // 当前选中分类
      activePoint: {
        id: '',
        name: '',
        code: '',
        businessType: '',
      }, // 当前选中的分类下节点
      categoryList: [], // 任务分类列表
      pointList: [], // 分类下节点列表
      list: [], // 节点下数据
      visible: false,
      configList: [], // 配置项列表
      defaultCheckedKeys: [], // 选中的节点
      icon: require('@/assets/icon_task_default.svg'),
      activeIcon: require('@/assets/icon_task.svg'),
    };
  },
  mounted () {
    this.init();
  },
  methods: {
    formatDate (text, format = 'YYYY-MM-DD HH:mm:ss') {
      return text ? Moment(text * 1).format(format) : '/';
    },
    refresh () {
      this.queryCategory();
    },
    reset () {
      this.$confirm('重置后，任务协作节点将恢复默认设置，是否确认重置？', '重置', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
      }).then(async () => {
        await resetConfig({ clientType: 'PC' });
        this.$message({
          type: 'success',
          message: '重置成功!',
        });
        this.init();
      });
    },
    changeActive (category) {
      this.active = category.id;
      this.pointList = category.nodeList;
      this.activePoint = {
        id: this.pointList[0].id,
        name: this.pointList[0].name,
        code: this.pointList[0].code,
        businessType: this.pointList[0].businessType,
      };
      this.queryTaskPageList();
    },
    changeActivePoint (point) {
      this.activePoint = {
        id: point.id,
        name: point.name,
        code: point.code,
        businessType: point.businessType,
      };
      this.queryTaskPageList();
    },
    allowDrop (draggingNode, dropNode, type) {
      if (draggingNode.data.level === dropNode.data.level) {
        if (draggingNode.data.parentId === dropNode.data.parentId) {
          return type === 'prev' || type === 'next';
        } else {
          return false;
        }
      } else {
        // 不同级进行处理
        return false;
      }
    },
    check (data, checkNodes) {
      // 点击的时候获取选中的节点，更改defaultCheckedKeys
      this.defaultCheckedKeys = checkNodes.checkedKeys;
    },
    handleCheckChange (data, checked, indeterminate) {
      data.enableFlag = checked;
      if (data.nodeList?.length && !indeterminate) {
        data.nodeList.map(node => { node.enableFlag = checked; });
      }
    },
    handleDrop () {
      // 拖拽之后会改变选中，再次默认选中
      this.$nextTick(() => {
        this.$refs.configListTree.setCheckedKeys(this.defaultCheckedKeys);
      });
    },
    toDetail (item) {
      if (this.$withPermission('workOrder:view')) {
        this.$router.push({
          name: 'ORDER_EDIT',
          query: {
            id: item.businessId,
            templateId: item.customizeTemplateId,
          },
        });
      } else {
        this.$message.warning('暂无权限');
      }
    },
    toListPage (status) {
      this.$router.push({
        name: 'ORDER_INDEX',
        params: {
          independentStatusMsg: [{
            value: taskEnums[status.code] || null,
            label: status.name,
          }],
        },
      });
    },
    async queryConfig () {
      const { body } = await getConfig('PC');
      let _defaultCheckedKeys = [];
      (body || []).map(item => {
        let count = 0;
        item.nodeList.map(item2 => {
          if (item2.enableFlag) count++;
          item2.enableFlag && _defaultCheckedKeys.push(item2.id);
          item2.parentId = item.id;
          return item2;
        });
        if (count === item.nodeList.length) {
          item.enableFlag = true;
        } else {
          item.enableFlag = false;
        }
        item.enableFlag && _defaultCheckedKeys.push(item.id);
        return item;
      });
      this.configList = body;
      this.defaultCheckedKeys = [...new Set(_defaultCheckedKeys)];
    },
    async notRemind (id) {
      await noAlert({id});
      this.queryCategory();
    },
    async handleSave () {
      let categoryList = [];
      let nodeList = [];
      this.configList.map((item, index) => {
        categoryList.push({
          taskCooperationCategoryId: item.id,
          enableFlag: item.nodeList.some(row => row.enableFlag) || false,
          serialNo: index + 1,
        });
        item.nodeList.map((item2, index2) => {
          nodeList.push({
            taskCooperationCategoryId: item2.parentId,
            taskCooperationNodeId: item2.id,
            enableFlag: item2.enableFlag,
            serialNo: index2 + 1,
          });
        });
      });

      let params = {
        clientType: 'PC',
        categoryList: [...categoryList],
        nodeList: [...nodeList],
      };
      await saveConfig(params);
      this.visible = false;
      this.init();
    },
    async queryTaskPageList () {
      let params = {
        taskCooperationNodeId: this.activePoint.id,
        alertFlag: true,
        clientType: 'PC',
        enablePage: true,
        orderBy: [
          {
            orderByProperty: 'lastUpdateTime',
            orderByType: 'DESC',
          },
        ],
        pageNum: 1,
        pageSize: 5,
      };
      this.list = [];
      const { body } = await taskPageList(params);
      this.list = body.list || [];
    },
    async queryCategory () {
      const { body } = await getCategoryAndCount('PC');
      this.categoryList = body || [];
      if (this.categoryList.length) {
        if (!this.active) {
          this.active = this.categoryList[0].id;
          this.pointList = this.categoryList[0].nodeList;
          this.activePoint = {
            id: this.pointList[0].id,
            name: this.pointList[0].name,
            code: this.pointList[0].code,
            businessType: this.pointList[0].businessType,
          };
        } else {
          const nowList = this.categoryList.find(item => this.active === item.id);
          this.pointList = nowList.nodeList;
        }
        this.activePoint && this.queryTaskPageList();
      }
    },
    init () {
      this.active = '';
      this.activePoint = {
        id: '',
        name: '',
        code: '',
        businessType: '',
      };
      this.categoryList = [];
      this.pointList = [];
      this.list = [];
      this.queryCategory();
    },
  },
};
</script>
<style lang="scss">
.task-collaboration-tree-node {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
<style lang="scss" scoped>
.cooperation-box {
  font-size: 14px;
  color: #1F2733;
  background-color: #ffffff;
  border-radius: 6px;
  padding: 15px 20px;
  margin-bottom: 8px;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ctrl-bar-left {
      display: inline-flex;
      align-items: center;
      .panel {
        font-size: 16px;
        font-weight: bold;
      }
      .type-box {
        margin-left: 20px;
        .type {
          cursor: default;
          margin-right: 10px;
          background: #F2F4F7;
          border-radius: 4px;
          padding: 4px 8px;
          font-weight: 400;
          font-size: 14px;
          color: #5F6A7A;
          &.active {
            background: #4A9EFF;
            color: #FFFFFF;
          }
        }
      }
    }
    .ctrl-bar-right {
      display: inline-flex;
      align-items: center;
      .ctrl {
        font-weight: 400;
        font-size: 14px;
        color: #929AA6;
        margin-left: 15px;
        cursor: pointer;
      }
    }
  }
  .content {
    padding-top: 15px;
    display: flex;
    .content-left {
      width: 200px;
      height: 365px;
      overflow-y: auto;
      border: 1px solid #EBEDF0;
      margin-right: 10px;
      flex-shrink: 0;
      .status-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        .flex-box {
          display: flex;
          align-items: center;
          width: 100%;
        }
        .status-icon {
          width: 16px;
          height: 16px;
        }
        .status-label {
          font-weight: 400;
          font-size: 14px;
          color: #1F2733;
          padding: 0 6px;
        }
        .status-count {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          background: #FF5959;
          font-size: 12px;
          color: #FFFFFF;
          position: relative;
        }
        .go {
          display: none;
        }
        &.active {
          background: #E2F3FE;
          .status-label {
            color: #237FFA;
          }
        }
        &:hover {
          cursor: default;
          background: #F5F7FA;
          .go {
            display: inline-block;
            width: 25px;
            height: 15px;
            padding: 0 5px;
            cursor: pointer;
            flex-shrink: 0;
          }
        }
      }
    }
    .content-right {
      width: 100%;
      height: 365px;
      overflow-y: scroll;
      padding-bottom: 40px;
      position: relative;
      display: flex;
      flex-direction: column;
      .row {
        border-radius: 6px;
        border: 1px solid #F5F7FA;
        padding: 5px 10px;
        margin-bottom: 10px;
        cursor: default;
        .line-1 {
          font-weight: 600;
          font-size: 13px;
          color: #1F2733;
        }
        .line-2 {
          padding-top: 5px;
          font-weight: 400;
          font-size: 12px;
          color: #929AA6;
          .item {
            padding-right: 15px;
          }
        }
        &:hover {
          background: #F5F7FA;
        }
      }
      .more {
        cursor: pointer;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 10px 0;
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: #237FFA;
      }
    }
  }
}
</style>
